import ApiClient from '@afosto/api/ApiClient';

class Routing {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Create a new hop
   *
   * @param {Object} body - Hop model
   * @param {Object} options - The additional request options
   * @description Add an hop
   * @returns {Promise}
   */
  createHop(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/hops`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Create a new route
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Add a new route
   * @returns {Promise}
   */
  createRoute(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/routes`,
      method: 'post',
      data: body,
      ...options,
    });
  }

  /**
   * Mark a hop as deleted
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Mark a hop as deleted
   * @returns {Promise}
   */
  deleteHop(id, options = {}) {
    return this.apiClient.request({
      url: `/wms/hops/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Mark a route as deleted
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Marks a route as deleted
   * @returns {Promise}
   */
  deleteRoute(id, options = {}) {
    return this.apiClient.request({
      url: `/wms/routes/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * Get a hop
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get a hop
   * @returns {Promise}
   */
  getHop(id, options = {}) {
    return this.apiClient.request({
      url: `/wms/hops/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of routes
   *
   * @param {Object} query - The optional path parameters
   * @param {Number} [query.deletedAt] - the timestamp to compare against
   * @param {Object} options - The additional request options
   * @description List all routes
   * @returns {Promise}
   */
  getRoutes(query = {}, options = {}) {
    const params = {
      deleted_at: query.deletedAt,
    };

    return this.apiClient.request({
      url: `/wms/routes`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Get a list of hops
   *
   * @param {Object} options - The additional request options
   * @description List all hops
   * @returns {Promise}
   */
  listHops(options = {}) {
    return this.apiClient.request({
      url: `/wms/hops`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Update the applied schedules on a hop
   *
   * @param {Object} body - Hop model
   * @param {Object} options - The additional request options
   * @description update the applied schedules
   * @returns {Promise}
   */
  updateHopSchedules(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/hops`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Update the name of a route
   *
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update a route
   * @returns {Promise}
   */
  updateRoute(body, options = {}) {
    return this.apiClient.request({
      url: `/wms/routes`,
      method: 'put',
      data: body,
      ...options,
    });
  }

  /**
   * Get a route
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description View a route
   * @returns {Promise}
   */
  viewRoute(id, options = {}) {
    return this.apiClient.request({
      url: `/wms/routes/${id}`,
      method: 'get',
      ...options,
    });
  }
}

export const routing = new Routing();

export default Routing;
